module.exports = __webpack_public_path__ + "static/scroll-pub-crop-974379d19ae52e52ef8ded31634b2185.jpeg";